import { getCookie } from '@atlassian/jira-browser-storage-controls/src/utils/get-cookie/index.tsx';
import { setCookie } from '@atlassian/jira-browser-storage-controls/src/utils/set-cookie/index.tsx';

export type NavModulesCollapsedType = {
	development: {
		isCollapsed: boolean;
	};
	operations: {
		isCollapsed: boolean;
	};
	planning: {
		isCollapsed: boolean;
	};
};
export type NavModuleStateDataShape = {
	classic: NavModulesCollapsedType;
	nextGen: NavModulesCollapsedType;
};

export const NAV_MODULES_UI_STORAGE_KEY = 'navigation_modules_ui_state' as const;

const defualtNavModulesState = {
	classic: {
		planning: {
			isCollapsed: false,
		},
		development: {
			isCollapsed: false,
		},
		operations: {
			isCollapsed: false,
		},
	},
	nextGen: {
		planning: {
			isCollapsed: false,
		},
		development: {
			isCollapsed: false,
		},
		operations: {
			isCollapsed: false,
		},
	},
} as const;

export const queryCookiesSync = (): NavModuleStateDataShape => {
	const cookieData = getCookie(NAV_MODULES_UI_STORAGE_KEY);

	if (!cookieData) {
		return defualtNavModulesState;
	}
	let parsedCookieData = null;
	try {
		parsedCookieData = JSON.parse(cookieData);
	} catch {
		// Rather than throw an error - just set the default state
		parsedCookieData = defualtNavModulesState;
	}
	return parsedCookieData;
};

const updateCookie = (data: NavModuleStateDataShape) =>
	setCookie(NAV_MODULES_UI_STORAGE_KEY, JSON.stringify(data));

export const setNavModulesCollapseState = (
	navState: NavModuleStateDataShape = defualtNavModulesState,
): void => {
	updateCookie({
		...defualtNavModulesState,
		...navState,
	});
};

export const useNavModulesCollapseState = (): NavModuleStateDataShape => {
	const uiState: NavModuleStateDataShape = queryCookiesSync();

	if (uiState) {
		return uiState;
	}

	setNavModulesCollapseState();
	return defualtNavModulesState;
};

export const getNavModulesVisibilityURL = (): string =>
	'/rest/greenhopper/1.0/profile/labs-panel/navigation-modules-visibility';
